import { render, staticRenderFns } from "./AdditionalMediaDetail.vue?vue&type=template&id=12b2aaca&scoped=true&"
import script from "./AdditionalMediaDetail.vue?vue&type=script&lang=js&"
export * from "./AdditionalMediaDetail.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalMediaDetail.vue?vue&type=style&index=0&id=12b2aaca&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b2aaca",
  null
  
)

export default component.exports